import { useState } from "react";
import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import React from "react";

const CustomerTopbar = () => {

  const [searchTerm, setSearchTerm] = useState("");

  const [Status, setStatus] = React.useState('default');
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [Plan, setPlan] = React.useState('default');
  const handlePlanChange = (event: SelectChangeEvent) => {
    setPlan(event.target.value as string);
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          {/* <div className="form">
            <div className="control_group">
              <Select
                fullWidth
                value={Status}
                onChange={handleStatusChange} >
                <MenuItem disabled value="default">Select Status</MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
                <MenuItem value="Suspended">Suspended</MenuItem>
                <MenuItem value="Reactivate">Reactivate</MenuItem>
              </Select>
            </div>
            <div className="control_group">
              <Select
                fullWidth
                value={Plan}
                onChange={handlePlanChange}
              >
                <MenuItem disabled value="default">Select Plan</MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Free">Free</MenuItem>
                <MenuItem value="Premium">Premium</MenuItem>
                <MenuItem value="Family">Family</MenuItem>
                <MenuItem value="Creator">Creator</MenuItem>
              </Select>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CustomerTopbar;
